lmApp
  .service('ContactsService', [function () {

    var service = {};

    return service;
  }]);
